import React from 'react';
import { FaQuestion } from 'react-icons/fa';
import { RiLockPasswordFill } from 'react-icons/ri';

import clsx from 'clsx';

import { useStyles } from './styles';

export function StepIconComponent(props) {
  const classes = useStyles();
  const { active, completed } = props;

  const icons = {
    1: <FaQuestion size='18' />,
    2: <RiLockPasswordFill size='18' />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}
